export const colors = {
  primaryTextColor: "#000000",
  primaryBgColor: "#ffbc33",
  hoverBtnColor: "#da9c22",
  secondaryTextColor: "#858598",
  thirdTextColor: "#a6abb9",
  modalBackdropBackground: "rgba(100, 74, 74, 0.2)",
  modalBoxShadowColor: "rgba(0, 0, 0, 0.25)",
  modalTextColor: "#ffffff",
  userLogoBgColor: "#2196F3",
  awardsErrorColor: "tomato",
  cardRewardColor: "#5679d7",
  cardDayPopupWindow: "#3e7adc",
  footerDeviderColor: "#e3e2e7",
  footerHomeMobileBgColor: "#f1f1f1",
  rewardAmountCircleColor: "#8ec63f",
};
